import "./ClientAllergiesFormComponent.scss";
import CardComponent from "../../../../shared/components/card/CardComponent";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import React, {useCallback, useEffect, useState} from "react";
import {IClientAllergiesForm} from "../../../../shared/models/client.model";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {Misc} from "../../../../constants";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {useDispatch} from "react-redux";
import _ from "lodash";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import HeadingWithNavigationComponent
    from "../../../../shared/components/heading-with-navigation/HeadingWithNavigationComponent";
import DetailsViewCardComponent from "../../../../shared/components/details-view-card/DetailsViewCardComponent";
import AcknowledgementFormComponent from "../../acknowledgement-form/AcknowledmentFormComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";

interface ClientAllergiesFormComponentProps {
    clientMedicalHistoryDetails: any;
    isClientMedicalHistoryDetailsLoaded: boolean | undefined;
    isClientMedicalHistoryDetailsLoading: boolean | undefined;
    isClientMedicalHistoryDetailsLoadingFailed: boolean | undefined;
    onCancel: () => void;
    onNext?: () => void;
    clientId: string;
    onSave: (clientAllergies: any) => void;
}


const ClientAllergiesFormInitialValues: IClientAllergiesForm = {
    allergies: ''
}

const ClientAllergiesFormComponent = (props: ClientAllergiesFormComponentProps) => {

    const {
        onCancel, onSave,
        clientId,
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoaded,
        isClientMedicalHistoryDetailsLoading,
        isClientMedicalHistoryDetailsLoadingFailed
    } = props;
    const [clientAllergiesFormInitialValues, setClientAllergiesFormInitialValues] = useState<IClientAllergiesForm>(_.cloneDeep(ClientAllergiesFormInitialValues));
    const [isClientAllergiesSavingInProgress, setIsClientAllergiesSavingSavingInProgress] = useState(false);
    const dispatch = useDispatch();
    const [isAcknowledgementModalOpen, setIsAcknowledgementModalOpen] = useState(false);

    const onSubmit = useCallback((values: any, {setErrors}: FormikHelpers<any>) => {
        setClientAllergiesFormInitialValues(values);
        setIsAcknowledgementModalOpen(true);
    }, [])

    const handleAcknowledgementFormSubmit = useCallback((acknowledgementValues: any) => {
        const payload = {
            ...clientAllergiesFormInitialValues,
            ...acknowledgementValues,
            update_type: "profile",
            client_id: clientId
        };
        setIsClientAllergiesSavingSavingInProgress(true);
        CommonService._client.ClientMedicalHistoryQuestionnaireAllergiesDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<IClientAllergiesForm>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setIsClientAllergiesSavingSavingInProgress(false);
                setClientAllergiesFormInitialValues(_.cloneDeep(clientAllergiesFormInitialValues));
                onSave(response);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_MESSAGE_KEY], 'error');
                setIsClientAllergiesSavingSavingInProgress(false);
            })
    }, [onSave,clientId,clientAllergiesFormInitialValues]);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientAllergiesFormInitialValues({
                allergies: clientMedicalHistoryDetails.allergies
            });
        }
    }, [dispatch, clientMedicalHistoryDetails]);

    return (
        <div className={'client-allergies-form-component'}>
            <>
                {
                    isClientMedicalHistoryDetailsLoading && <div>
                        <LoaderComponent/>
                    </div>
                }
                {
                    isClientMedicalHistoryDetailsLoadingFailed &&
                    <StatusCardComponent title={"Failed to fetch medical Details"}/>
                }
            </>
            {
                isClientMedicalHistoryDetailsLoaded && <>
                    <HeadingWithNavigationComponent onBackNavigation={onCancel}
                                                    title={"Back"}/>
                    <Formik initialValues={clientAllergiesFormInitialValues}
                            onSubmit={onSubmit}
                            validateOnChange={false}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            validateOnMount={true}>
                        {({values, isValid, validateForm}) => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            useEffect(() => {
                                validateForm();
                            }, [validateForm, values]);
                            return (<CardComponent>
                                    <div className={'edit-allergies-heading'}>
                                        Edit Allergies
                                    </div>
                                    <Form noValidate={true} className={"t-form"}>
                                        <div className={'allergies-wrapper'}>
                                            <DetailsViewCardComponent title={'Allergies'}>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field name={'allergies'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikTextAreaComponent
                                                                        id={'allergies_input'}
                                                                        formikField={field}
                                                                        label={'Please list any allergies you have (ie. Medications, Food, Environmental, Insects, Adhesives, etc.):'}
                                                                        fullWidth={true}
                                                                        rows={3}
                                                                        placeholder={'Enter your comments here'}/>
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col-1"/>
                                                </div>
                                            </DetailsViewCardComponent>
                                        </div>
                                        <div className="t-form-actions pdd-left-20">
                                            <ButtonComponent
                                                id={"home"}
                                                variant={"outlined"}
                                                disabled={isClientAllergiesSavingInProgress}
                                                onClick={onCancel}
                                                color={'accent'}
                                                className={'mrg-right-15'}
                                            >
                                                Cancel
                                            </ButtonComponent>&nbsp;&nbsp;
                                            <ButtonComponent
                                                id={"save_next_btn"}
                                                isLoading={isClientAllergiesSavingInProgress}
                                                disabled={isClientAllergiesSavingInProgress || !isValid}
                                                type={"submit"}
                                                color={'accent'}
                                            >
                                                Next
                                                {/*{isClientAllergiesSavingInProgress ? "Saving" : "Save"}*/}
                                            </ButtonComponent>
                                        </div>
                                    </Form>
                                </CardComponent>
                            )
                        }}

                    </Formik>
                    <ModalComponent isOpen={isAcknowledgementModalOpen}>
                        <AcknowledgementFormComponent setIsAcknowledgementModalOpen={setIsAcknowledgementModalOpen}
                                                      isLoading={isClientAllergiesSavingInProgress}
                                                      onSubmit={handleAcknowledgementFormSubmit}/>
                    </ModalComponent>
                </>
            }
        </div>
    );

};

export default ClientAllergiesFormComponent;
